type Props = {
  size: number;
  color?: string;
};

const Bathtub = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3333 2.25C16.4021 2.25 17.2535 2.51935 17.9173 2.96191C18.5764 3.40134 19.0066 3.98232 19.2855 4.54004C19.5627 5.09469 19.6982 5.64043 19.765 6.04102C19.7986 6.24286 19.8158 6.41276 19.8245 6.53516C19.8289 6.59637 19.8311 6.64633 19.8323 6.68262C19.8329 6.70078 19.8331 6.71629 19.8333 6.72754V6.74902C19.8333 6.74902 19.8333 6.75 19.0833 6.75H19.8333V14.25H20.5833C21.4117 14.25 22.0833 14.9216 22.0833 15.75V17.25C22.0833 19.7353 20.0686 21.75 17.5833 21.75H7.08331C4.59803 21.75 2.58331 19.7353 2.58331 17.25V15.75C2.58331 14.9216 3.25489 14.25 4.08331 14.25H18.3333V6.75098L18.3323 6.73242C18.3317 6.71379 18.3304 6.68329 18.3275 6.64258C18.3216 6.55998 18.3094 6.43655 18.2845 6.28711C18.2341 5.98471 18.135 5.59254 17.9437 5.20996C17.7538 4.83033 17.4807 4.47357 17.0853 4.20996C16.6944 3.9494 16.1396 3.75 15.3333 3.75C14.5271 3.75 13.9722 3.9494 13.5814 4.20996C13.3214 4.38326 13.1148 4.59718 12.9495 4.83105C13.9189 5.32827 14.5833 6.33563 14.5833 7.5H8.58331C8.58331 5.90513 9.82786 4.60121 11.3987 4.50586C11.678 3.95859 12.1035 3.39244 12.7493 2.96191C13.4132 2.51935 14.2646 2.25 15.3333 2.25ZM4.08331 17.25C4.08331 18.9069 5.42646 20.25 7.08331 20.25H17.5833C19.2402 20.25 20.5833 18.9069 20.5833 17.25V15.75H4.08331V17.25Z"
        fill={color || '#868686'}
      />
    </svg>
  );
};

export default Bathtub;
